import { useContext, useState } from "react";
import { Link } from "react-router-dom";
import sair from "../../assets/img/Sair.svg";
import {
  Agrup, ButtonRotina, ContainerMenu,
  ContainerSwitchTheme, Icon, Input,
  Organize, SideBar, SideBarFooter,
  SideBarHeader, Slider, SliderRound,
  Switch
} from './style';
import { AuthContext } from "../../context/Auth";
import { ThemeContext } from "../../Provider/ThemeProvider";
import { clearToken } from "../../utils/validateToken";
import { MenuPG } from "./menuPg";
import { MenuCrm } from "./menuCrm";
import { MenuCadastro } from "./menuCadastro";
import { MenuBatismo } from "./menuBatismo";
import { MenuAcolher } from "./menuAcolher";
import { MenuCheckin } from "./menuCheckIn";
import { Grid, IconButton } from "@mui/material";
import MenuOpenRoundedIcon from '@mui/icons-material/MenuOpenRounded';
import PersonRoundedIcon from '@mui/icons-material/PersonRounded';
import MenuRoundedIcon from '@mui/icons-material/MenuRounded';

export default function Menu({
  onClose, onOpen, isOpen
}: {
  onClose: VoidFunction, onOpen: VoidFunction, isOpen: boolean
}) {
  const { setAuth, login } = useContext<any>(AuthContext);

  function Quit() {
    setAuth(false);
    clearToken();
  }


  return (
    <ContainerMenu $open={!isOpen}>
      <SideBarHeader>
        <Grid display={'flex'} width={'100%'} alignItems={'center'} gap={1} p={2}>
          <PersonRoundedIcon sx={{ fill: '#fff' }} />
          <p style={{
             fontSize: '14px',
             fontWeight: '500',
             color: '#fff',
             overflow: 'hidden', maxLines: 2, maxHeight: 35, maxWidth: 100, textOverflow: 'ellipsis' }}>{login}</p>
        </Grid>
        <IconButton onClick={!isOpen ? onOpen : onClose} style={ isOpen ? {
          transform: 'translateX(50px)',
          position: 'absolute',
          zIndex: 11
        }: {

         }}>
          {
            !isOpen ?
              <MenuOpenRoundedIcon />
              :
              <MenuRoundedIcon />
          }
        </IconButton>
      </SideBarHeader>
      <SideBar>
        <MenuCadastro />
        <MenuCrm />
        <MenuAcolher />
        <MenuCheckin />
        <MenuPG />
        <MenuBatismo />
        <ButtonRotina>
          <Link to={'/dash/'}>
            <Organize onClick={Quit}>
              <Agrup>
                <Icon src={sair} />
                <p>Sair</p>
              </Agrup>
            </Organize>
          </Link>
        </ButtonRotina>

      </SideBar>
      <SideBarFooter>
        <ButtonRotina className="footer">
         
        </ButtonRotina>
      </SideBarFooter>
    </ContainerMenu >
  )
}
